<template>
	<div class="tw-flex tw--mx-10">
		<p-card class="tw-w-full tw-flex tw-flex-col">
			<div class="tw-flex tw-justify-start tw-items-center tw-w-72">
				<v-select
					outline
					single-line
					hide-details
					class="select-core"
					:items="entities"
					item-value="id"
					item-text="alias"
					return-object
					@input="getEntites($event)"
					>
				</v-select>
				<v-menu
					offset-x
					rigth
					:nudge-rigth="97"
					max-height="300"
					fixed
					content-class="columns-menu"
					class="options-menu">
						<button
							color="transparent"
							slot="activator">
							<v-tooltip top>
							<img
								src="/static/img/ellipsis.svg"
								alt=""
								slot="activator"
								class="align-img tw-pl-6"
								height="20">
								<span>Ver más</span>
							</v-tooltip>
						</button>
					<v-list>
						<v-list-tile>
							<v-list-tile-title class="tw-pb-10">
								<app-tooltip-button
									img="/static/img/plus.svg"
									text="Agregar Entidad"
									@click-icon="addEntity"
								/>
							</v-list-tile-title>
							<v-list-tile-title class="tw-pb-10">
								<app-tooltip-button
									:img="`${$imageUrl}/edit.svg`"
									text="Editar Entidad"
									:disabled="!disabledBtn"
									@click-icon="editTypeEntity"
								/>
							</v-list-tile-title>
							<v-list-tile-title class="tw-pb-10">
								<app-tooltip-button
									:img="`${$imageUrl}/delete-button.svg`"
									text="Eliminar Entidad"
									:disabled="!disabledBtn"
									@click-icon="deleteTypeEntity"
								/>
							</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</div>
			<app-table
				class="mb-0 mt-3 no-main-list"
				:columns="columns"
				:filter-columns="false"
				:main-list="true"
				:rows="entitiesDetails"
				btn-actions>
				<template slot="action">
					<app-button
						:disabled="!disabledBtn"
						class="btn-tool"
						icon="add"
						:style="`background-color:${$appColors.primary}`"
						@click="addDetailToEntity"
					/>
				</template>
				<template slot="rows" slot-scope="props">
					<td style="text-align: left; width: 30%; padding-left: 40px;" v-show="showRow(columns, 1)">{{ props.row.code }}</td>
					<td v-show="showRow(columns, 2)">{{ props.row.nameField }}</td>
					<td v-show="showRow(columns, 3)">{{ props.row.alias }}</td>
					<td v-show="showRow(columns, 4)">
						<template>
							<app-tooltip-button
								:img="`${$imageUrl}/edit.svg`"
								text="Editar"
								@click-icon="editEntityDetail(props.row)"
							/>
							<app-tooltip-button
								:img="`${$imageUrl}/delete-button.svg`"
								text="Eliminar"
								@click-icon="deleteEntityDetail(props.row)"
							/>
						</template>
					</td>
				</template>
			</app-table>
		</p-card>
		<v-dialog
			v-model="createEntity"
			persistent
			max-width="750">
				<p-card class="tw-p-none overflow-hidden">
					<p-header-dialog :negative-margin="false" @closeClicked="close()"></p-header-dialog>
					<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
						<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
							<v-text-field
								label="Nombre"
								solo
								hide-details
								class="input-text"
								v-model="modelEntity.name"
							></v-text-field>
							<!-- <span
								v-if="$v.verb.name.$invalid"
								class="message-error"
								:style="`color:${$appColors.error}`"
							>
								El nombre es requerido
							</span> -->
						</label>
						<label :style="`color:${$appColors.info}; width: 100%;`">Alias:
							<v-text-field
								label="Alias"
								solo
								hide-details
								class="input-text"
								v-model="modelEntity.alias"
							></v-text-field>
							<!-- <span
								v-if="$v.verb.name.$invalid"
								class="message-error"
								:style="`color:${$appColors.error}`"
							>
								El nombre es requerido
							</span> -->
						</label>
					</section>
					<p-horizontal-divider></p-horizontal-divider>
					<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
						<p-button
							:disabled="!modelEntity.name || !modelEntity.alias"
							type="primary"
							@click="saveNewEntity"
							> Guardar
						</p-button>
					</div>
				</p-card>
		</v-dialog>
		<v-dialog
			v-model="createEntityDetails"
			persistent
			max-width="750">
				<p-card class="tw-p-none overflow-hidden">
					<p-header-dialog :negative-margin="false" @closeClicked="close()"></p-header-dialog>
					<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
						<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
							<v-text-field
								label="Nombre"
								solo
								hide-details
								class="input-text"
								v-model="modelEntityDetails.name"
							></v-text-field>
						</label>
						<label :style="`color:${$appColors.info}; width: 100%;`">Alias:
							<v-text-field
								label="Alias"
								solo
								hide-details
								class="input-text"
								v-model="modelEntityDetails.alias"
							></v-text-field>
						</label>
					</section>
					<p-horizontal-divider></p-horizontal-divider>
					<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
						<p-button
							:disabled="!modelEntityDetails.name || !modelEntityDetails.alias"
							type="primary"
							@click="saveNewEntityDetails"
							> Guardar
						</p-button>
					</div>
				</p-card>
		</v-dialog>
		<p-confirm-dialog ref="confirmDeleteDialogEntity"></p-confirm-dialog>
		<p-confirm-dialog ref="confirmDeleteDialogEntityDetail"></p-confirm-dialog>
	</div>
</template>

<script>
	import PCard from '@/modules/shared/components/ui/Card/p-card';
	import PButton from '@/modules/shared/components/ui/p-button';
	import appButton from '@/components/shared/app-button';
	import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
	import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';
	import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';

	export default {
		name: 'page-entities',
		data() {
			return {
				entities: [],
				entitiesDetails: [],
				params: {},
				typeEntities: {},
				typeEntityDetail: {},
				columns: [
					{
						id: 1,
						name: 'Código',
						value: 'code',
						visible: true,
						checked: true,
					},
					{
						id: 2,
						name: 'Nombre de Campo',
						value: 'name',
						visible: true,
						checked: true,
					},
					{
						id: 3,
						name: 'Alias',
						value: 'alias',
						visible: true,
						checked: true,
					},
					{
						id: 4,
						name: 'Acciones',
						visible: true,
					},
				],
				createEntity: false,
				modelEntity: {
					name: null,
					alias: null,
				},
				createEntityDetails: false,
				modelEntityDetails: {
					name: null,
					alias: null,
				},
				flagEdit: false,
			};
		},
		created() {
			this.loadData();
		},
		components: {
			PCard,
			PButton,
			appButton,
			PHorizontalDivider,
			PConfirmDialog,
			PHeaderDialog,
		},
		methods: {
			clearModels() {
				this.modelEntity.name = null;
				this.modelEntity.alias = null;
				this.modelEntityDetails.name = null;
				this.modelEntityDetails.alias = null;
			},
			async loadData() {
				const params = {
					sortField: 'alias',
					sortDirection: 'ASC',
				};
				try {
					const { data: response } = await this.$httpPraktiko.get('entities', { params });
					this.entities = response;
				} catch (error) {
					this.showGenericError();
				}
			},
			getEntites(typeEntities) {
				this.typeEntities = typeEntities;
				this.loadEntitiesDetails();
			},
			async loadEntitiesDetails() {
				const params = { ...this.params };
				try {
					const { data: response } = await this.$httpPraktiko.get(`/entities-details/${this.typeEntities.id}`, { params });
					this.entitiesDetails = response;
				} catch (error) {
					this.showGenericError();
				}
			},
			addEntity() {
				this.createEntity = true;
			},
			async saveNewEntity() {
				const url = this.flagEdit ? `entities/${this.typeEntities.id}` : 'entities';
				const method = this.flagEdit ? 'patch' : 'post';
				const message = this.flagEdit ? 'Editada' : 'Creada';
				const body = {
					code: this.modelEntity.name.toLowerCase().trim(),
					name: this.modelEntity.name,
					alias: this.modelEntity.alias,
				};
				if (this.flagEdit) {
					delete body.code;
				}
				try {
					await this.$httpPraktiko[method](url, body);
					this.showNotification(`Entidad ${message} Correctamente`);
					this.loadData();
				} catch (error) {
					this.showGenericError();
				} finally {
					this.createEntity = false;
					this.clearModels();
					this.flagEdit = false;
				}
			},
			async editTypeEntity() {
				try {
					if (Object.keys(this.typeEntities).length !== 0) {
						const { data: response } = await this.$httpPraktiko.get(`/entities/detail/${this.typeEntities.id}`);
						this.modelEntity.name = response.name;
						this.modelEntity.alias = response.alias;
						this.createEntity = true;
						this.flagEdit = true;
					}
				} catch (error) {
					this.showGenericError();
				}
			},
			deleteTypeEntity() {
				this.$refs.confirmDeleteDialogEntity.showConfirm({
					onOk: async () => {
						try {
							await this.$httpPraktiko.delete(`entities/${this.typeEntities.id}`);
							this.typeEntities = {};
							this.loadData();
						} catch (error) {
							this.showGenericError();
						}
					},
					title: `¿Seguro que desea eliminar "${this.typeEntities.alias}" de la lista?.`,
				});
			},
			addDetailToEntity() {
				this.createEntityDetails = true;
			},
			async saveNewEntityDetails() {
				const url = this.flagEdit ? `entities-details/${this.typeEntityDetail.id}` : 'entities-details';
				const method = this.flagEdit ? 'patch' : 'post';
				const message = this.flagEdit ? 'Actualizo' : 'Agrego';
				const body = {
					entityId: this.typeEntities.id,
					code: this.modelEntityDetails.name.toLowerCase().trim(),
					nameField: this.modelEntityDetails.name,
					alias: this.modelEntityDetails.alias,
				};
				if (this.flagEdit) {
					delete body.code;
				}
				try {
					await this.$httpPraktiko[method](url, body);
					this.showNotification(`Detalle ${message} Correctamente`);
					this.loadEntitiesDetails();
				} catch (error) {
					this.showGenericError();
				} finally {
					this.createEntityDetails = false;
					this.clearModels();
					this.flagEdit = false;
				}
			},
			async editEntityDetail(row) {
				this.typeEntityDetail = row;
				try {
					const { data: response } = await this.$httpPraktiko.get(`entities-details/detail/${row.id}`);
					this.modelEntityDetails.name = response.nameField;
					this.modelEntityDetails.alias = response.alias;
					this.createEntityDetails = true;
					this.flagEdit = true;
				} catch (error) {
					this.showGenericError();
				}
			},
			deleteEntityDetail(row) {
				this.$refs.confirmDeleteDialogEntityDetail.showConfirm({
					onOk: async () => {
						try {
							await this.$httpPraktiko.delete(`entities-details/${row.id}`);
							this.typeEntityDetail = {};
							this.loadEntitiesDetails();
						} catch (error) {
							this.showGenericError();
						}
					},
					title: `¿Seguro que desea eliminar "${row.alias}" de la lista?.`,
				});
			},
			close() {
				this.createEntity = false;
				this.createEntityDetails = false;
				this.clearModels();
				this.flagEdit = false;
			},
		},
		computed: {
			disabledBtn() {
				return Object.keys(this.typeEntities).length > 0;
			},
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/configuration/page-entities.vue